export default "__VITE_ASSET__D$p27Fer__"